import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.element.addEventListener("turbo:submit-start", function(event) {
      // console.log("ClearInvalidFields turbo:submit-start");
      const invalid = event.target.querySelectorAll(".is-invalid");

      invalid.forEach((element) => {
	element.classList.remove("is-invalid");
      });
    });
  }
}
